const getOffset = (limit: number, currentPage: number) => limit * (currentPage - 1);

export {
  getOffset,
}

export default null;
